/**
 * Calendrier de réservation — Calendly (Ypsys Informatique)
 * Page « 30 min » : embed iframe sur ThankYouPage, lien direct pour fallback / window.open.
 */
export const BOOKING_MEETING_PAGE_URL = 'https://calendly.com/ypsys-informatique/30min';

/** Query `embed_type=Inline` requise par Calendly pour l’affichage en iframe */
export const BOOKING_EMBED_URL = `${BOOKING_MEETING_PAGE_URL}?embed_type=Inline`;

/** Lien pleine page (sans embed) — ex. ouverture dans un nouvel onglet */
export const BOOKING_CALENDAR_URL = BOOKING_MEETING_PAGE_URL;
